import { render } from "./EventShirtSettings.vue?vue&type=template&id=6ce38f4c"
import script from "./EventShirtSettings.vue?vue&type=script&lang=js"
export * from "./EventShirtSettings.vue?vue&type=script&lang=js"
script.render = render

export default script